import { apiClient, ENDPOINTS } from '@/lib/api';

/**
 * Una persona del padrón global, con todos los portales a los que entra.
 *
 * `ultimoIngreso` viaja como string ISO 8601 (pasa por `res.json()`, no llega
 * como `Date`) y `activo` es la CUENTA, no la membresía: una cuenta
 * desactivada no entra a ningún portal —el login la corta antes que nada—
 * pero sus membresías siguen siendo reales, por eso el padrón las sigue
 * listando. Ver `padron.service.ts` en el backend.
 */
export type PersonaDelPadron = {
  id: string;
  nombre: string;
  email: string;
  ultimoIngreso: string | null;
  activo: boolean;
  /**
   * Hasta cuándo puede entrar, en ISO 8601, o `null` si no vence. La pantalla
   * es la que compara con "hoy" y decide si dice «(vencido)»: el servidor manda
   * el dato, no el juicio.
   */
  expiraEl: string | null;
  portales: { slug: string; empresa: string; rol: string }[];
};

export async function traerPadron(): Promise<PersonaDelPadron[]> {
  return apiClient.get<PersonaDelPadron[]>(ENDPOINTS.ADMIN_PERSONAS);
}
